"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const base_button_js_1 = require("./base-button.js");
const IconButton = React.forwardRef(({ className, ...props }, forwardedRef) => (React.createElement(base_button_js_1.BaseButton, { ...props, ref: forwardedRef, className: (0, classnames_1.default)('rt-IconButton', className) })));
exports.IconButton = IconButton;
IconButton.displayName = 'IconButton';
//# sourceMappingURL=icon-button.js.map